export default __webpack_public_path__ + "static/media/IMG_1112.e7dadb90.JPG";